import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";

/*
  A center's own Consultant Partners (owner, 2026-10-10).

  The center registers a consultant itself instead of waiting for somebody to
  sign up on the website, and every student that consultant brings is filed
  under this center.

  Add returns the server's whole { status, data, message } so the form can show
  the field errors it sends back - a duplicate email or mobile is the common
  case and the center needs to be told which one.
*/

const token = () => localStorage.getItem("centerToken");

export const getCenterPartners = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("center/b2b/partners", token()));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const addCenterPartner = (body) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("center/b2b/partners", body, token())
    );
    return response.data;
  } catch (error) {
    /* 400 carries the field errors, 409 a duplicate. Both are answers the
       form has to show, not failures to swallow. */
    if (error && error.response && error.response.data) {
      return error.response.data;
    }
    return { status: "failed", message: "The partner could not be added." };
  }
};
